var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#219E48",
    stroke: "#22562A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M79.387,62.67c0,3.438-2.787,6.225-6.224,6.225 H26.057c-3.438,0-6.224-2.787-6.224-6.225V21.982c0-3.438,2.786-6.224,6.224-6.224h47.106c3.437,0,6.224,2.786,6.224,6.224V62.67z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#219E48",
    stroke: "#22562A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M76.355,80.561c0,2.084-1.344,3.772-3,3.772 H25.864c-1.657,0-3-1.688-3-3.772V67.27c0-2.084,1.343-3.771,3-3.771h47.492c1.656,0,3,1.688,3,3.771V80.561L76.355,80.561z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#219E48",
    stroke: "#22562A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M22.921,70.754c0,1.658-1.532,3-3.422,3h-6.38 c-1.89,0-3.422-1.342-3.422-3L4.014,38.25c-1.625-7.451,1.792-10.175,5.104-10.175h10.38c1.89,0,3.422,1.343,3.422,3L22.921,70.754 L22.921,70.754z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#219E48",
    stroke: "#22562A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M76.301,70.742c0,1.658,1.531,3,3.422,3h6.381 c1.893,0,3.422-1.342,3.422-3l5.685-32.504c1.625-7.451-1.793-10.175-5.104-10.175H79.723c-1.891,0-3.422,1.343-3.422,3V70.742z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedSeat);
export default __webpack_public_path__ + "static/media/selected_seat.1184b77caa8898a497f391e68696c5de.svg";
export { ForwardRef as ReactComponent };